<div class="wrapper-search-results">
  @for (i of renderArray; track $index) {
    <ui-product-card-skeleton></ui-product-card-skeleton>
  }
</div>
